import React from 'react';
import useGetPageListItem from '../../hooks/useGetPageListItem';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { PreviewThemeType } from '../../../../areas/public-site/theme/ThemePage';

const TextWrapper = styled.div(({ theme }: { theme: PreviewThemeType }) => {
    return {
        margin: 'auto',
        paddingTop: '2rem',
        paddingBottom: '2rem',
        width: '70%',
        color: theme.colors.textColor1,
        '*': {
            backgroundColor: `${theme.colors.pageBackground} !important`,
        },
    };
});

const PreviewText = ({ ...rest }) => {
    const { data: pageListItem } = useGetPageListItem();
    const theme = useTheme<PreviewThemeType>();

    return (
        <TextWrapper theme={theme} {...rest}>
            <p dangerouslySetInnerHTML={{ __html: pageListItem?.description || '' }} />
        </TextWrapper>
    );
};

export default PreviewText;
